export default __webpack_public_path__ + "static/media/1.c35a6ca4.png";